import {Component} from 'react';
import AddCardModal from "../modals/AddCardModal";
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import DeleteCardConfirmModal from "../modals/DeleteCardConfirmModal";
import FastCreditModal from "../modals/FastCreditModal";
import Badge from 'react-bootstrap/lib/Badge';
import Button from 'react-bootstrap/lib/Button';
import CardSub from "../subcomponents/CardSub";
import AzureTable from "../AzureTable";
import LoadingModal from "../modals/LoadingModal";
import DeleteDialog from "../../utils/modals/higher/DeleteDialog";
import RecipeScreen from "../screens/RecipeScreen";
import FormDialog from "../../utils/modals/FormDialog";
import {Alert} from "react-bootstrap";
import request from 'request-promise-native';

const GET_CARDS_URL = "https://qibipay.azurewebsites.net/api/GetUsersList";
const ADD_USER_URL = "https://qibipay.azurewebsites.net/api/UserAdd";
const REMOVE_USER_URL = "https://qibipay.azurewebsites.net/api/UserDisable";
const MAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


class RecipesTab extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addUserOpen: false,
            addUserFailed: null,
            addUserSuccess: null,
            addingUser: false,

            loading: true
        };

    }

    async addUser(mail) {

        this.setState({
            addingUser: true,
            addUserSuccess: null,
            addUserFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_USER_URL,
            body: {
                access_code: this.props.access_code,
                mail,
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addUserSuccess: response.body,
                addingUser: false,
            });
            this.tableRef.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addUserFailed: response.body,
            addingUser: false,
        });

    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-group"></i> Users <a href="javascript:void(0);" style={{
                                fontSize: "15px"
                            }} onClick={() => {
                                this.tableRef.resetTable();
                            }}><i className="fa fa-sync"></i></a></h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addUserOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add User
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteDialog access_code={this.props.access_code}
                              logout={this.props.logout}
                              url={REMOVE_USER_URL}
                              questionText="Do you really want to remove this user?"
                              questionTitle="Remove user"
                              successTitle="User remove success"
                              successText="User has been successfully removed!"
                              failedTitle="User remove failed"
                              failedText="Error during user removal!"
                              loadingTitle="Removing user..."
                              sendParams={["id"]}
                              onSuccess={() => this.tableRef.resetTable()}
                              dialogRef={ref => this.userDeleteDialogRef = ref}/>

                <FormDialog open={this.state.addUserOpen}
                            onClose={() => {
                                this.setState({
                                    addUserOpen:false,
                                    addUserFailed: null,
                                    addUserSuccess: null
                                })
                            }}
                            titleText="Add user"
                            submitText="Add user"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return MAIL_REGEX.test(value) ? null : "Not a valid e-mail!";
                                    },
                                    name: "E-Mail",
                                    type: "text",
                                    placeholder: "Enter admin's e-mail"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const mail = obj["E-Mail"];
                                this.addUser.bind(this)(mail);
                            }}
                            notification={this.state.addUserSuccess ? (<Alert bsStyle="success"><strong>{this.state.addUserSuccess}</strong></Alert>) : this.state.addUserFailed ? (<Alert bsStyle="danger"><strong>{this.state.addUserFailed}</strong></Alert>) : ""}
                            loading={this.state.addingUser}/>

                <LoadingModal title="Loading..."
                            text="Loading users data..."
                            open={this.state.loading}/>

                <div className="container-fluid">
                    <AzureTable
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_CARDS_URL}
                        defaultSorted={[
                            {
                                id: "email",
                                desc: false
                            }
                        ]}
                        columns={[
                            {
                                Header: "Username",
                                accessor: "username",
                                filterable: true,
                                sortable: false,
                            },
                            {
                                Header: "E-mail",
                                accessor: "email",
                                sortable: true,
                                filterable: true
                            },
                            {
                                Header: "Claimed",
                                accessor: "claimed",
                                sortable: false,
                                filterable: false,
                                maxWidth: 64,
                                Cell: (row) => {
                                    if(row.original.ttl<0 || row.original.ttl==null) {
                                        return (
                                            <Badge><i className="fa fa-check"/></Badge>
                                        );
                                    } else {
                                        let str = "";

                                        const seconds = row.original.remaining;

                                        let minutes = seconds/60;

                                        const hours = Math.floor(minutes/60);
                                        minutes = Math.floor(minutes%60);

                                        str+=hours+" hours";

                                        if(minutes!==0) {
                                            str+=" and "+minutes+" minutes";
                                        }

                                        str+=" remaining";

                                        return (
                                            <div>
                                                <Badge><i className="fa fa-times"/></Badge> <Badge>{str}</Badge>
                                            </div>
                                        );
                                    }
                                }
                            },
                            {
                                Header: "Password reset URL",
                                accessor: "pwdResetUrl",
                                Cell: (row) => {
                                    return row.original.pwdResetUrl==null ? "" : row.original.pwdResetUrl;
                                },
                                sortable: false,
                                filterable: false
                            },
                            {
                                Header: "Sign-up URL",
                                accessor: "claimUrl",
                                Cell: (row) => {
                                    return row.original.claimUrl==null ? "" : row.original.claimUrl;
                                },
                                sortable: false,
                                filterable: false
                            },
                            {
                                Header: "",
                                accessor: "claimUrl",
                                maxWidth: 32,
                                Cell: (row) => {
                                    return (
                                        <a href="javascript:void(0);" onClick={() => {
                                            this.userDeleteDialogRef.open(row.original);
                                        }}><i className="fa fa-trash"></i></a>
                                    )
                                },
                                sortable: false,
                                filterable: false
                            }
                        ]}
                        filterable
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </div>
            </div>
        );
    }
}

export default RecipesTab;